import { useCallback } from 'react';
import MunicipalPortalAAppService from 'application/platform/municipal-portal-service';
import { downloadFile } from 'utils/download-file';
import { usePrestacaoContasDetailsDispatch } from './prestacao-contas-details-context';
import { ACTION_TYPES } from './prestacao-contas-details-reducer';

export const usePrestacaoContasDetailsController = () => {
  const dispatch = usePrestacaoContasDetailsDispatch();

  const loadPrestacaoContasDetails = useCallback(async (id: number) => {
    try {
      dispatch({ type: ACTION_TYPES.setLoading, payload: true });
      dispatch({ type: ACTION_TYPES.setError, payload: null });

      const response = await MunicipalPortalAAppService.getPrestacaoContas(id);

      dispatch({ type: ACTION_TYPES.setPrestacaoContasDetails, payload: response });
    } catch (error) {
      console.error('Error loading prestacao contas details:', error);
      dispatch({ type: ACTION_TYPES.setError, payload: 'Erro ao carregar detalhes da prestação de contas' });
      dispatch({ type: ACTION_TYPES.setPrestacaoContasDetails, payload: null });
    } finally {
      dispatch({ type: ACTION_TYPES.setLoading, payload: false });
    }
  }, [dispatch]);

  const clearPrestacaoContasDetails = useCallback(() => {
    dispatch({ type: ACTION_TYPES.setPrestacaoContasDetails, payload: null });
    dispatch({ type: ACTION_TYPES.setError, payload: null });
  }, [dispatch]);

  const exportPrestacaoContasDetail = useCallback(async (id: number, format: string) => {
    const file = await MunicipalPortalAAppService.exportPrestacaoContasDetail(id, format);
    downloadFile(file);
  }, []);

  return {
    loadPrestacaoContasDetails,
    clearPrestacaoContasDetails,
    exportPrestacaoContasDetail,
  };
};
